import { defineStore } from 'pinia'
import { ref, shallowRef } from 'vue'

export type ShareModalContent = {
    title: string
    cover: string
    text: string
    url: string
}

export const useShareModalStore = defineStore('share-modal', () => {
    const isOpened = ref(false)
    const content = shallowRef<ShareModalContent>()
    let resolveShared: ((shared: boolean) => void) | undefined
    let requestId = 0

    function settle(shared: boolean) {
        resolveShared?.(shared)
        resolveShared = undefined
    }

    function open(next: ShareModalContent): Promise<boolean> {
        settle(false)
        requestId += 1
        content.value = next
        isOpened.value = true
        return new Promise((resolve) => {
            resolveShared = resolve
        })
    }

    function getRequestId() {
        return requestId
    }

    function markShared(id: number) {
        if (id !== requestId) {
            return false
        }
        settle(true)
        return true
    }

    function close() {
        settle(false)
        requestId += 1
        isOpened.value = false
    }

    return { isOpened, content, open, getRequestId, markShared, close }
})
